'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
const input = require('./input');
exports.input = input;
const output = require('./output');
exports.output = output;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bitcoinjs-lib/src/templates/witnessscripthash/index.js
// module id = dh+R
// module chunks = 6